import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import ReactMarkdown from 'react-markdown';

import { TaskContent } from '../../../types/game-document/entities/task-content';
import { GetResourceValue } from '../../../utils/game-document';
import { GameDocumentContext } from '../../../contexts/game-document';

interface TaskPremessageDialogProps {
  taskContent?: TaskContent;
  toggle: () => void;
  onContinue: () => void;
}

export const TaskPremessageDialog: React.FC<TaskPremessageDialogProps> = ({
  taskContent,
  toggle,
  onContinue
}) => {
  const [state] = React.useContext(GameDocumentContext);
  const premessageContent = GetResourceValue(
    state.gameDocument!,
    taskContent?.preMessageResId!
  );

  return (
    <div className={`pre-message-dialog__mask`}>
      <div className={`pre-message-dialog`}>
        <div className={`pre-message-dialog__body overflow-auto`}>
          <>
            {taskContent?.bodyType === 'HTML' ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: premessageContent ?? ''
                }}
              />
            ) : (
              <ReactMarkdown>{premessageContent ?? ''}</ReactMarkdown>
            )}
            <div className={'d-flex'}>
              <Button
                id={'btn-task-content-premessage-close'}
                themeColor={'secondary'}
                fillMode={'outline'}
                className={'mt-4 mr-4'}
                onClick={toggle}>
                Close
              </Button>

              <Button
                id={'btn-task-content-premessage-continue'}
                themeColor={'success'}
                fillMode={'solid'}
                className={'mt-4'}
                onClick={onContinue}>
                Continue
              </Button>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};
